import { CnButton, formilyReact } from '@cainiaofe/cn-ui';
const { useField } = formilyReact;
export function CnButtonProxy(props) {
    const { onClick } = props;
    const extraProps = {};
    if (onClick) {
        let field;
        try {
            field = useField();
        }
        catch (e) { }
        extraProps.onClick = () => {
            onClick({
                field,
            });
        };
    }
    return <CnButton {...props} {...extraProps}/>;
}
